export function getContrastColor(hexColor: string) {
  if (hexColor.startsWith("#")) {
    hexColor = hexColor.slice(1);
  }

  const r = parseInt(hexColor.slice(0, 2), 16) / 255;
  const g = parseInt(hexColor.slice(2, 4), 16) / 255;
  const b = parseInt(hexColor.slice(4, 6), 16) / 255;

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance < 0.5 ? "#E3E5E8" : "#171717";
}
